{
    "features-debit-card-discounts": {
        "meta": {
            "title": "Discounts - MAJORITY",
            "description": "Save when you spend at local restaurants, grocery stores, and more in your community!"
        },
        "hero": {
            "title": "MAJORITY Discounts",
            "body": "Swipe with pride and save at any of our community discount partners. Spend less on groceries, restaurants, and more!"
        }
    }
}